@file:Suppress("MagicNumber", "TooGenericExceptionCaught")

package com.nonopn.skydome.common.app.pages.estimate

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.Icon
import androidx.compose.material.icons.Icons
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.vector.rememberVectorPainter
import androidx.compose.ui.platform.UriHandler
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.nonopn.geolocation.GpsLocation
import com.nonopn.geolocation.GpsResult
import com.nonopn.icons.Pin
import com.nonopn.skydome.common.app.api.GeocodeLatLng
import com.nonopn.skydome.common.app.api.Mode
import com.nonopn.skydome.common.app.api.impl.EstimateRequest
import com.nonopn.skydome.common.app.api.impl.ThunderDetectionEstimate
import com.nonopn.skydome.common.app.detection.ThunderDetection
import com.nonopn.skydome.common.app.home.AppModel
import com.nonopn.skydome.common.app.navigation.RouterEstimates
import com.nonopn.skydome.common.app.navigation.RouterEstimatesAdmin
import com.nonopn.skydome.common.app.pages.main.model.ComposeSelectedPositionHolder
import com.nonopn.skydome.common.app.pages.main.model.ComposeSimpleProjectHolder
import com.nonopn.skydome.common.app.pages.main.model.IMapAction
import com.nonopn.skydome.common.app.pages.main.model.MapActionLookUpState
import com.nonopn.skydome.common.app.pages.main.model.SpecificData
import com.nonopn.skydome.common.app.pages.main.model.api.Probe
import com.nonopn.skydome.common.app.pages.main.model.api.Project
import com.nonopn.skydome.common.app.pages.main.model.sessionLookUpId
import com.nonopn.skywatcher.app.utils.safeLaunch
import com.nonopn.skywatcher.app.utils.takeIf
import com.nonopn.skywatcher.common.api.ApiSession
import com.nonopn.skywatcher.common.app.res.Res
import com.nonopn.skywatcher.common.app.res.estimate_no_email_set_text
import com.nonopn.skywatcher.common.app.res.estimate_no_email_set_title
import com.nonopn.skywatcher.common.app.res.estimate_side_effect_activated_now
import com.nonopn.skywatcher.common.app.res.estimate_side_effect_activated_with_deadline
import com.nonopn.skywatcher.common.app.res.estimate_side_effect_deactivated
import com.nonopn.skywatcher.common.app.res.estimate_test_checkout_validate_text
import com.nonopn.skywatcher.common.app.res.estimate_test_checkout_validate_title
import com.nonopn.skywatcher.common.app.res.estimate_validate_text
import com.nonopn.skywatcher.common.app.res.estimate_validate_title
import com.nonopn.skywatcher.design.theme.AppColor
import eu.codlab.compose.widgets.TextNormal
import com.nonopn.skywatcher.design.widgets.popup.PopupLocalModel
import com.nonopn.skywatcher.maps.LatLng
import com.nonopn.skywatcher.maps.MapUtils
import com.nonopn.skywatcher.maps.providers.GoogleProvider
import eu.codlab.viewmodel.StateHandler
import eu.codlab.viewmodel.StateViewModel
import eu.codlab.viewmodel.launch
import korlibs.io.util.UUID
import korlibs.time.DateTime
import korlibs.time.DateTimeTz
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.FlowPreview
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.debounce
import org.jetbrains.compose.resources.StringResource
import org.jetbrains.compose.resources.getString
import ovh.plrapps.mapcompose.api.ExperimentalClusteringApi
import ovh.plrapps.mapcompose.api.addLayer
import ovh.plrapps.mapcompose.api.addMarker
import ovh.plrapps.mapcompose.api.addPath
import ovh.plrapps.mapcompose.api.centroidSnapshotFlow
import ovh.plrapps.mapcompose.api.enableFlingZoom
import ovh.plrapps.mapcompose.api.enableRotation
import ovh.plrapps.mapcompose.api.enableScrolling
import ovh.plrapps.mapcompose.api.enableZooming
import ovh.plrapps.mapcompose.api.maxScale
import ovh.plrapps.mapcompose.api.onTap
import ovh.plrapps.mapcompose.api.referentialSnapshotFlow
import ovh.plrapps.mapcompose.api.removeMarker
import ovh.plrapps.mapcompose.api.removePath
import ovh.plrapps.mapcompose.api.scale
import ovh.plrapps.mapcompose.api.setMagnifyingFactor
import ovh.plrapps.mapcompose.api.snapScrollTo
import ovh.plrapps.mapcompose.core.TileStreamProvider
import ovh.plrapps.mapcompose.ui.state.MapState
import ovh.plrapps.mapcompose.ui.state.OnActionListener
import kotlin.math.max
import kotlin.math.min
import kotlin.math.pow
import kotlin.time.Duration.Companion.seconds

const val MaxZoom = 3.0
const val MinZoom = 0.00003
const val DefaultZoom = 0.003

data class EstimateScreenModelState(
    val initialized: Boolean = false,
    val currentCoordinates: LatLng? = null,
    val currentZoom: Double? = null,
    val updatingCoordinates: Boolean = false,
    val apiSession: ApiSession? = null,
    val uuid: String? = null,
    val probes: List<Probe> = emptyList(),
    val projects: List<Project> = emptyList(),
    val dashboardProbes: List<ThunderDetection> = emptyList(),
    val areProbesSkySentinel: Boolean = false,
    val estimateEmail: String = "",
    val isWithEndDate: Boolean = false,
    val selectedEndDate: DateTimeTz? = null,
    val areEnabled: Boolean = false,
    val isExternalContract: Boolean = false,
    val selectedMarkerLabel: String? = null,
)

enum class EstimateValidationMode {
    UserCanpay,
    AdminCanValidate,
    ReadOnly,
}

interface EstimateScreenModel : StateHandler<EstimateScreenModelState>, IMapAction {
    fun configureMapState()

    val levelCount: Int
    val fullWidthOrHeight: Int
    val mapState: MapState

    var scope: CoroutineScope?

    var mode: Mode

    val validationMode: EstimateValidationMode

    fun updateCurrentInterface(mode: Mode) = Unit

    fun setSkySentinelMode(isSkySentinel: Boolean)

    fun setAreEnabled(areEnabled: Boolean) = Unit

    fun setIsExternalContract(isExternalContract: Boolean) = Unit

    fun setEmail(email: String)

    fun validateEstimate(popup: PopupLocalModel) = Unit

    fun checkoutEstimate(popup: PopupLocalModel, uriHandler: UriHandler) = Unit

    fun setIsWithAndEndDate(hasEndDate: Boolean) = Unit

    fun setSelectedEndDate(date: DateTimeTz) = Unit

    fun explanation(): StringResource {
        val state = states.value
        return when {
            state.areEnabled && state.isWithEndDate && state.selectedEndDate != null ->
                Res.string.estimate_side_effect_activated_with_deadline

            state.areEnabled -> Res.string.estimate_side_effect_activated_now

            else -> Res.string.estimate_side_effect_deactivated
        }
    }
}

@OptIn(FlowPreview::class)
@Suppress("TooManyFunctions")
class EstimateScreenModelImpl(
    private val appModel: AppModel,
    override var mode: Mode,
    private val existingEstimate: ThunderDetectionEstimate? = null,
) : StateViewModel<EstimateScreenModelState>(
    EstimateScreenModelState(
        probes = existingEstimate?.probes?.map {
            Probe(
                latitude = it.latitude,
                longitude = it.longitude,
                name = UUID.randomUUID().toString(),
                radiusKm = 100,
                enabled = true,
                isMain = !existingEstimate.isSkySentinel,
                isVirtual = existingEstimate.isSkySentinel
            )
        } ?: emptyList(),
        areProbesSkySentinel = existingEstimate?.isSkySentinel ?: false,
        estimateEmail = existingEstimate?.email ?: "",
        areEnabled = existingEstimate?.areEnabled ?: false,
        isWithEndDate = existingEstimate?.validUntilSecondsUtc != null,
        selectedEndDate = existingEstimate?.validUntilSecondsUtc?.let {
            DateTime.fromUnixMillis(it * 1000).local
        },
        isExternalContract = existingEstimate?.isExternalContract ?: false,
        uuid = existingEstimate?.uuid,
    )
),
    EstimateScreenModel {
    private val _lookUpState = MutableStateFlow(MapActionLookUpState())
    override val lookUpState = _lookUpState.asStateFlow()
    private val googleApi = GoogleProvider()

    private val tileStreamProvider = TileStreamProvider { row, col, zoomLvl ->
        googleApi.getTile(row, col, zoomLvl)
    }

    override val validationMode: EstimateValidationMode
        get() = when (mode) {
            Mode.Normal -> {
                if (null != existingEstimate) {
                    EstimateValidationMode.ReadOnly
                } else {
                    EstimateValidationMode.UserCanpay
                }
            }

            Mode.Admin -> EstimateValidationMode.AdminCanValidate
        }

    override fun updateCurrentInterface(mode: Mode) {
        this.mode = mode
    }

    private fun radius(isSkySentinel: Boolean) = if (isSkySentinel) {
        50
    } else {
        100
    }

    override fun setSkySentinelMode(isSkySentinel: Boolean) {
        updateState {
            println("setSkySentinelMode($isSkySentinel)")
            val updatedProbes = probes.map {
                it.copy(
                    isSkysentinel = isSkySentinel,
                    radiusKm = radius(isSkySentinel)
                )
            }

            updatedProbes.forEach { addMarker(it) }

            copy(
                areProbesSkySentinel = isSkySentinel,
                probes = updatedProbes
            )
        }
    }

    override fun setAreEnabled(areEnabled: Boolean) {
        safeLaunch {
            updateState { copy(areEnabled = areEnabled) }
        }
    }

    override fun setIsExternalContract(isExternalContract: Boolean) {
        safeLaunch {
            updateState { copy(isExternalContract = isExternalContract) }
        }
    }

    override fun setEmail(email: String) {
        updateState {
            copy(
                estimateEmail = email
            )
        }
    }

    private val onActionListener = object : OnActionListener {
        override fun onLongPress(x: Double, y: Double) = Unit

        override fun onPress() {
            // nothing
        }

        override fun onTap(x: Double, y: Double) = Unit

        override fun onTouchDown() = Unit
    }

    override val levelCount = 18
    override val fullWidthOrHeight = 256 * 2.0.pow(levelCount).toInt()

    private val selectedPointComposer: ComposeSelectedPositionHolder
    private val projectsComposer: ComposeSimpleProjectHolder
    private val gpsLocation = GpsLocation()

    @OptIn(ExperimentalClusteringApi::class)
    override val mapState = MapState(
        levelCount,
        fullWidthOrHeight,
        fullWidthOrHeight,
        tileSize = 256,
        onActionListener = onActionListener
    ).apply {
        onTap { x, y -> onNewDetectionCircle(x, y) }
        setMagnifyingFactor(0)

        maxScale = MaxZoom
        scale = DefaultZoom
        addLayer(tileStreamProvider)

        enableRotation()
    }

    init {
        println("CREATING NEW MainScreenModel")

        selectedPointComposer = ComposeSelectedPositionHolder(
            mapState = mapState,
            flushCallouts = ::flushCallouts
        )

        projectsComposer = ComposeSimpleProjectHolder(
            mapState = mapState,
            flushCallouts = ::flushCallouts
        )
        safeLaunch {
            // update the state
            states.value.probes.forEach { addMarker(it) }
        }

        safeLaunch {
            val specificData = appModel.getSpecificData()

            val latLng = specificData?.coordinates ?: LatLng(0.0, 0.0)
            val xy = MapUtils.latLngToXY(latLng)

            val zoom = specificData?.zoom ?: MinZoom

            googleApi.initialize()

            updateState {
                copy(
                    currentCoordinates = latLng,
                    currentZoom = zoom,
                    initialized = true
                )
            }

            loadData()

            setZoom(zoom)
            mapState.snapScrollTo(
                xy.x,
                xy.y
            )

            safeLaunch {
                mapState.referentialSnapshotFlow().debounce(1.seconds).collect { ref ->
                    updateState { copy(currentZoom = ref.scale) }

                    states.value.currentCoordinates?.let { writeSpecificData(it, ref.scale) }
                }
            }

            safeLaunch {
                mapState.centroidSnapshotFlow().debounce(1.seconds).collect {
                    val coords = MapUtils.xyToLatLng(it.x, it.y)

                    updateState { copy(currentCoordinates = coords) }

                    if (coords.latitude == 0.0 || coords.longitude == 0.0) return@collect

                    writeSpecificData(coords, states.value.currentZoom ?: MinZoom)
                }
            }
        }
    }

    private fun writeSpecificData(
        coords: LatLng,
        zoom: Double
    ) {
        appModel.writeSpecificData(
            SpecificData(
                zoom = zoom,
                coordinates = coords
            )
        )
    }

    override fun onCleared() {
        println("CLEARED MainScreenModel")

        super.onCleared()
    }

    override var scope: CoroutineScope? = null

    override fun configureMapState() {
        mapState.enableZooming()
        mapState.enableScrolling()
        mapState.enableFlingZoom()
    }

    override fun zoomIn() = applyZoom(1.1)

    override fun zoomOut() = applyZoom(0.9)

    private fun applyZoom(coef: Double) {
        // make sure that we are both 3.0f > scale > 0.05f
        val newZoom = mapState.scale * coef
        setZoom(max(min(newZoom, MaxZoom), MinZoom))
    }

    private fun setZoom(zoom: Double) {
        mapState.scale = zoom

        safeLaunch {
            updateState { copy(currentZoom = zoom) }

            states.value.currentCoordinates!!.let {
                writeSpecificData(it, zoom)

                val coords = MapUtils.latLngToXY(it.latitude, it.longitude)
                mapState.snapScrollTo(coords.x, coords.y)
            }
        }
    }

    @OptIn(ExperimentalClusteringApi::class)
    private fun loadData() = safeLaunch(
        onError = {
            it.printStackTrace()
        }
    ) {
        updateState { copy(updatingCoordinates = true) }

        val currentInterface = when (mode) {
            Mode.Normal -> appModel.states.value.apiProvider?.apiNormal!!
            Mode.Admin -> appModel.states.value.apiProvider?.apiAdmin!!
        }

        val data = currentInterface.estimatesData()
        val projects = data.map { it.project }

        println("having projects -> ${projects.size}")

        projects.forEachIndexed { index, project ->
            val xy = MapUtils.latLngToXY(project.latitude, project.longitude)

            mapState.addMarker(
                "project_$index",
                xy.x,
                xy.y,
            ) {
                Column(
                    Modifier.width(14.dp).height(20.dp)
                        .clickable { showMarkerLabel(project.name, xy.x, xy.y) },
                ) {
                    Icon(
                        painter = rememberVectorPainter(Icons.Rounded.Pin),
                        contentDescription = "Project",
                        tint = AppColor.White,
                    )
                }
            }
        }

        // Show existing probes as blue markers with tap-to-show-name
        val existingProbes = appModel.cachedDashboardReports().map { it.probe }
        val currentEstimateProbeUuids = existingEstimate?.probes
            ?.map { it.uuid }?.toSet() ?: emptySet()

        existingProbes.forEachIndexed { index, probe ->
            // Skip probes that belong to the current estimate (avoid duplicates)
            if (probe.uuid in currentEstimateProbeUuids) return@forEachIndexed

            val xy = MapUtils.latLngToXY(probe.latitude, probe.longitude)

            // Clickable blue marker — tap to show name
            mapState.addMarker(
                "existing_probe_$index",
                xy.x,
                xy.y
            ) {
                Column(
                    Modifier.width(14.dp).height(20.dp)
                        .clickable { showMarkerLabel(probe.name, xy.x, xy.y) },
                ) {
                    Icon(
                        painter = rememberVectorPainter(Icons.Rounded.Pin),
                        contentDescription = "Existing probe",
                        tint = AppColor.Blue,
                    )
                }
            }

            // Coverage circle — thick visible border
            mapState.addPath(
                id = "existing_probe_circle_$index",
                width = 5.dp,
                color = AppColor.Blue,
                fillColor = AppColor.Blue.copy(alpha = 0.08f),
            ) {
                MapUtils.circle(probe.position(), 100_000) {
                    MapUtils.latLngToXY(this).toPair()
                }?.let { list -> this.addPoints(list) }
            }
        }

        updateState {
            copy(
                updatingCoordinates = false,
                projects = projects,
                dashboardProbes = existingProbes,
            )
        }
    }

    override fun moveTo(location: GeocodeLatLng) {
        safeLaunch {
            val latLng = LatLng(location.latitude, location.longitude)
            val xy = MapUtils.latLngToXY(latLng)

            updateState { copy(initialized = true) }

            mapState.scale = MaxZoom
            mapState.snapScrollTo(
                xy.x,
                xy.y
            )
        }
    }

    override fun moveToOrigin() {
        mapState.scale = DefaultZoom

        safeLaunch {
            println("moveToOrigin")
            try {
                when (val loc = gpsLocation.current()) {
                    is GpsResult.GeolocationFailed -> {
                        println("failed!")
                    }

                    is GpsResult.NotFound -> {
                        println("failed!")
                    }

                    is GpsResult.NotSupported -> {
                        println("failed!")
                    }

                    is GpsResult.PermissionDenied -> {
                        println("failed!")
                    }

                    is GpsResult.Success -> {
                        val latLng =
                            loc.location.coordinates.let { LatLng(it.latitude, it.longitude) }
                        val xy = MapUtils.latLngToXY(latLng)

                        updateState { copy(initialized = true) }

                        mapState.snapScrollTo(
                            xy.x,
                            xy.y
                        )
                    }
                }
            } catch (err: Throwable) {
                println("err loading coordinates ${err.message}")
            }
        }
    }

    private fun onNewDetectionCircle(x: Double, y: Double) {
        // If a marker label is showing, clear it and do nothing else
        if (states.value.selectedMarkerLabel != null) {
            clearMarkerLabel()
            return
        }

        val latLng = MapUtils.xyToLatLng(x, y)

        val foundExistingProbe = states.value.probes.find {
            MapUtils.distance(latLng, it.latLng()) < 10 && it.isMain
        }

        if (null != foundExistingProbe) {
            removeProbeFromObject(foundExistingProbe)
            return
        }

        Probe(
            latitude = latLng.latitude,
            longitude = latLng.longitude,
            name = UUID.randomUUID().toString(),
            radiusKm = 100,
            enabled = true,
            isMain = true,
            isVirtual = false
        ).let {
            println("addMarker $it")
            addMarker(it)

            addProbeToObject(it)
        }
    }

    private fun removeProbeFromObject(probe: Probe) {
        launch {
            val newProbes = states.value.probes.filter { it.name != probe.name }

            println("removePath ${probe.name}")
            mapState.removePath(probe.name)
            mapState.removeMarker("marker_${probe.name}")

            updateState {
                copy(
                    probes = newProbes
                )
            }
        }
    }

    private fun addProbeToObject(probe: Probe) {
        launch {
            val newProbes = states.value.probes + probe
            updateState {
                copy(
                    probes = newProbes
                )
            }
        }
    }

    private fun flushCallouts() {
        mapState.onPress()
    }

    private fun showMarkerLabel(label: String, x: Double, y: Double) {
        // Remove previous label if any
        mapState.removeMarker("marker_label")

        // Add label marker above the tapped position
        mapState.addMarker("marker_label", x, y) {
            Column(
                horizontalAlignment = Alignment.CenterHorizontally,
            ) {
                TextNormal(
                    label,
                    modifier = Modifier
                        .background(
                            Color(0xE0202840),
                            RoundedCornerShape(8.dp)
                        )
                        .padding(horizontal = 10.dp, vertical = 4.dp),
                    fontSize = 12.sp,
                    fontWeight = FontWeight.SemiBold,
                    color = Color.White,
                )
                Spacer(Modifier.height(6.dp))
                // Space for the pin icon below
                Spacer(Modifier.height(20.dp))
            }
        }

        updateState { copy(selectedMarkerLabel = label) }
    }

    private fun clearMarkerLabel() {
        mapState.removeMarker("marker_label")
        updateState { copy(selectedMarkerLabel = null) }
    }

    private fun addCircle(
        probe: Probe,
        radiusMeter: Int,
        color: Color = Color.Transparent
    ) {
        val xy = MapUtils.latLngToXY(probe.latitude, probe.longitude).toPair()
        mapState.addMarker(
            "marker_${probe.name}",
            x = xy.first,
            y = xy.second,
        ) {
            Column(
                // normally 22 x 30
                Modifier.width(14.dp).height(20.dp)
                    .clickable {
                        removeProbeFromObject(probe)
                    }
            ) {
                Icon(
                    painter = rememberVectorPainter(Icons.Rounded.Pin),
                    contentDescription = "Selected Position",
                    tint = AppColor.RedDarker,
                )
            }
        }

        mapState.addPath(
            id = probe.name,
            width = 5.dp,
            color = color,
            fillColor = AppColor.OrangeSemiTransparent,
        ) {
            MapUtils.circle(probe.coordinates(), radiusMeter) {
                MapUtils.latLngToXY(this).toPair()
            }?.let { list -> this.addPoints(list) }
        }
    }

    private fun addMarker(probe: Probe) {
        println("addMarker(${probe.name})")
        mapState.removePath(probe.name)
        mapState.removeMarker("marker_${probe.name}")

        addCircle(
            probe,
            probe.radiusKm * 1000,
            color = AppColor.RedDarker
        )
    }

    override fun validateEstimate(popup: PopupLocalModel) {
        safeLaunch {
            popup.show(
                title = getString(Res.string.estimate_validate_title),
                text = getString(Res.string.estimate_validate_text),
                onConfirm = {
                    onValidateEstimate(popup)
                }
            )
        }
    }

    override fun checkoutEstimate(popup: PopupLocalModel, uriHandler: UriHandler) {
        safeLaunch {
            popup.show(
                title = getString(Res.string.estimate_test_checkout_validate_title),
                text = getString(Res.string.estimate_test_checkout_validate_text),
                onConfirm = {
                    onValidateCheckout(popup, uriHandler)
                }
            )
        }
    }

    override fun setIsWithAndEndDate(hasEndDate: Boolean) {
        safeLaunch(onError = { it.printStackTrace() }) {
            updateState { copy(isWithEndDate = hasEndDate) }
        }
    }

    override fun setSelectedEndDate(date: DateTimeTz) {
        safeLaunch(onError = { it.printStackTrace() }) {
            updateState { copy(selectedEndDate = date) }
        }
    }

    private fun onValidateCheckout(popup: PopupLocalModel, uriHandler: UriHandler) = safeLaunch(
        onError = {
            popup.show("Error", it.message ?: "Unknown error")
        }
    ) {
        var uuid = states.value.uuid

        if (null == uuid) {
            val validUntilSecondsUtc = takeIf(states.value.isWithEndDate) {
                states.value.selectedEndDate?.utc?.unixMillisLong?.let { it / 1000 }
            }

            val answer = appModel.states.value.currentApi!!.createEstimate(
                EstimateRequest(
                    uuid = states.value.uuid,
                    email = states.value.estimateEmail,
                    areEnabled = states.value.areEnabled,
                    isSkySentinel = states.value.areProbesSkySentinel,
                    validUntilSecondsUtc = validUntilSecondsUtc,
                    positions = states.value.probes.map {
                        LatLng(
                            latitude = it.latitude,
                            longitude = it.longitude
                        )
                    }
                )
            )

            updateState { copy(uuid = answer.uuid) }
            uuid = answer.uuid
        }

        val answer = appModel.states.value.currentApi!!.estimateCheckout(uuid)

        uriHandler.openUri(answer.redirectUrl)
    }

    private fun onValidateEstimate(popup: PopupLocalModel) = safeLaunch(
        onError = {
            popup.show("Error", it.message ?: "Unknown error")
        }
    ) {
        val validUntilSecondsUtc = takeIf(states.value.isWithEndDate) {
            states.value.selectedEndDate?.utc?.unixMillisLong?.let { it / 1000 }
        }

        if (mode == Mode.Admin && states.value.estimateEmail.isBlank()) {
            popup.show(
                title = getString(Res.string.estimate_no_email_set_title),
                text = getString(Res.string.estimate_no_email_set_text)
            )

            return@safeLaunch
        }

        println(states.value.estimateEmail)
        println(states.value.estimateEmail)
        println(states.value.estimateEmail)
        println(states.value.estimateEmail)
        println(states.value.estimateEmail)

        appModel.states.value.currentApi!!.createEstimate(
            EstimateRequest(
                uuid = states.value.uuid,
                email = states.value.estimateEmail,
                areEnabled = states.value.areEnabled,
                isSkySentinel = states.value.areProbesSkySentinel,
                validUntilSecondsUtc = validUntilSecondsUtc,
                positions = states.value.probes.map {
                    LatLng(
                        latitude = it.latitude,
                        longitude = it.longitude
                    )
                }
            )
        )

        val navigateTo = when (mode) {
            Mode.Normal -> RouterEstimates.navigateTo()
            Mode.Admin -> RouterEstimatesAdmin.navigateTo()
        }

        appModel.show(navigateTo)
    }

    override fun explanation() = when {
        states.value.areEnabled && null != states.value.selectedEndDate -> Res.string.estimate_side_effect_activated_with_deadline
        states.value.areEnabled -> Res.string.estimate_side_effect_activated_now
        else -> Res.string.estimate_side_effect_deactivated
    }

    override fun lookUp(address: String) {
        safeLaunch {
            try {
                sessionLookUpId++
                val currentId = sessionLookUpId

                _lookUpState.tryEmit(
                    MapActionLookUpState(
                        lookingUp = true,
                        address = address,
                    )
                )

                val currentInterface = when (mode) {
                    Mode.Normal -> appModel.states.value.apiProvider?.apiNormal!!
                    Mode.Admin -> appModel.states.value.apiProvider?.apiAdmin!!
                }

                val results = currentInterface.geocoding(address)

                if (currentId != sessionLookUpId) {
                    // skipped
                    return@safeLaunch
                }

                _lookUpState.tryEmit(
                    MapActionLookUpState(
                        lookingUp = false,
                        address = address,
                        results = results,
                    )
                )
            } catch (err: Exception) {
                err.printStackTrace()

                _lookUpState.tryEmit(
                    MapActionLookUpState(
                        lookingUp = false,
                        address = address,
                        results = emptyList()
                    )
                )
            }
        }
    }
}

class FakeEstimateScreenModel(
    private val updating: Boolean = false,
    private val probes: List<Probe> = emptyList(),
    override var mode: Mode = Mode.Normal,
    override val validationMode: EstimateValidationMode = EstimateValidationMode.ReadOnly,
) : EstimateScreenModel {
    override fun configureMapState() = Unit

    override fun zoomIn() = Unit

    override fun zoomOut() = Unit

    override fun moveToOrigin() = Unit

    override val lookUpState = MutableStateFlow(MapActionLookUpState())

    override fun lookUp(address: String) = Unit

    override fun moveTo(location: GeocodeLatLng) = Unit

    override val levelCount: Int = 8
    override val fullWidthOrHeight: Int = 6
    override val mapState: MapState
        get() = MapState(levelCount, fullWidthOrHeight, fullWidthOrHeight)

    override var scope: CoroutineScope? = null

    override val states: StateFlow<EstimateScreenModelState>
        get() = MutableStateFlow(
            EstimateScreenModelState(
                updatingCoordinates = updating,
                probes = probes
            )
        )

    override fun setState(state: EstimateScreenModelState) = Unit

    override fun updateState(block: EstimateScreenModelState.() -> EstimateScreenModelState) =
        Unit

    override fun setSkySentinelMode(isSkySentinel: Boolean) = Unit

    override fun setEmail(email: String) = Unit
}
